import { useEffect, useState } from "react";

import { FooterDesktop } from "Components/organisms/Footer/Desktop";
import { FooterMobile } from "Components/organisms/Footer/Mobile";
import { FooterProps } from "Components/organisms/Footer/types";
import { footerItems } from "shared/config/footerItemsConfig";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

import TravelOptionsImage from "assets/images/mascots/tavel-options.png";
// @ts-ignore
import { ReactComponent as LogoVoopter } from "assets/svgs/logo-voopter.svg";

/**
 * Dados do rodapé
 */
const footerData: FooterProps = {
  travelOptionsImage: TravelOptionsImage,
  travelOptionsImageAlt:
    "Pessoa pensativa com ícones de viagem e economia ao redor",
  logo: LogoVoopter,
  footerItems: footerItems as FooterProps["footerItems"],
  descriptionTexts: [
    "Voopter é uma ferramenta que compara e encontra as melhores passagens aéreas na Internet, portanto não emite reservas, nem vende passagens aéreas ou pacotes de viagens.",
    "Consulte diretamente a sua companhia aérea ou agência de viagens para qualquer dúvida ou gestão da sua reserva ou passagem aérea.",
  ],
  subFooterText:
    "© Voopter (VOOPTER NEGÓCIOS DE INTERNET LTDA 40.030.657/0001-16)",
};

/**
 * Componente FooterTemplate
 *
 * Renderiza o rodapé alternando entre as versões Desktop e Mobile com base no tamanho da tela.
 */
export function FooterTemplate() {
  const [desktop, setDesktop] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setDesktop(
      breakpoint === "xxl" || breakpoint === "xl" || breakpoint === "lg",
    );
  }, [breakpoint]);

  return desktop ? (
    <FooterDesktop {...footerData} />
  ) : (
    <FooterMobile {...footerData} />
  );
}
